import { render, staticRenderFns } from "./IconIntegrations.vue?vue&type=template&id=4e3b8467"
import script from "./IconIntegrations.vue?vue&type=script&lang=js"
export * from "./IconIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports